// extracted by mini-css-extract-plugin
module.exports = {"image":"ImageUpload_image__F5bSo"};